import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { LanguageService } from '../services/language.service';
@Injectable({
  providedIn: 'root',
})
export class ApiHeaderInterceptor implements HttpInterceptor {
  constructor(private languageService: LanguageService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!/^(http|https):/i.test(request.url)) {
      request = request.clone({
        headers: request.headers.set('X-Client-Type', 'customer-portal'),
      });

      if (
        request.url.startsWith('/org/sgs/') ||
        request.url.startsWith('/org/hadirSms/')
      ) {
        request = request.clone({
          headers: request.headers.set(
            'Accept-Language',
            this.languageService.getLanguage(),
          ),
        });
      }
    }
    return next.handle(request);
  }
}
